import domReady from '@wordpress/dom-ready';
import { _x } from '@wordpress/i18n';
import Swiper from 'swiper';

domReady(() => {
  const partnersCarousels = document.querySelectorAll(
    '.partners-carousel-block-01 .partners-carousel__carousel'
  );

  if (0 < partnersCarousels.length) {
    partnersCarousels.forEach((carousel) => {
      new Swiper(carousel, {
        slidesPerView: 'auto',
        spaceBetween: 30,
        watchOverflow: true,
        navigation: {
          nextEl: carousel
            .closest('.partners-carousel-block-01')
            .querySelector('.vtx-swiper__next'),
          prevEl: carousel
            .closest('.partners-carousel-block-01')
            .querySelector('.vtx-swiper__prev'),
        },
        breakpoints: {
          300: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          600: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          768: {
            slidesPerView: 'auto',
          },
        },
        a11y: {
          enabled: true,
          scrollOnFocus: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: _x(
            'Carousel',
            'swiper accessibility',
            'vtx'
          ),
          prevSlideMessage: _x(
            'Go to previous slide',
            'swiper accessibility',
            'vtx'
          ),
          nextSlideMessage: _x(
            'Go to next slide',
            'swiper accessibility',
            'vtx'
          ),
          slideLabelMessage: _x(
            'Slide {{index}} of {{slidesLength}}',
            'swiper accessibility',
            'vtx'
          ),
        },
      });
    });
  }
});
